const initialState = {
    isFetchingUsersCount : false,
    adminDeleted: false
}

const adminReducer = (state =initialState , action) => {
    switch(action.type){
        case 'DELETE_ADMIN_SUCCESS':
            return {...state, adminDeleted: true};
        default :
        return state;
    }
}

export default adminReducer;